import { Controller } from '@hotwired/stimulus'

const VISIBLE_POSITION = 400

export default class extends Controller {
  initialize () {
    this._lastScrollPosition = 0
    this._ticking = false
    this._onScroll = () => {
      this._lastScrollPosition = window.scrollY
      const isEnabled = this.element.classList.contains('js-enable')

      if (!this._ticking && isEnabled) {
        window.requestAnimationFrame(() => {
          this.toggleVisibility(this._lastScrollPosition)
          this._ticking = false
        })

        this._ticking = true
      }
    }
    window.addEventListener('scroll', this._onScroll)
  }

  disconnect () {
    if (this._onScroll) {
      window.removeEventListener('scroll', this._onScroll)
    }
  }

  get className () {
    return this.element.dataset.classname
  }

  toggleVisibility (scrollPosition) {
    if (scrollPosition > VISIBLE_POSITION) {
      this.element.classList.add(`${this.className}::visible`)
    } else {
      this.element.classList.remove(`${this.className}::visible`)
    }
  }
}
